import { Go, SubscriptionNav, UsageAltNav } from '@clearkit/icons';
import { CKActionMenu, CKNavigationBarMenu, CKSkeleton } from 'clearkit';
import { Link } from 'react-router-dom';

import { useCreditUsage } from '~/hooks/account/useCreditUsage';

import { Metric } from '../home/HomeSidebar';
import { MeterBox } from '../home/MeterBox';

export const UsageMenu = () => {
  const {
    credits,
    creditsUsed,
    hasUsage,
    hasCredits,
    loading,
    planId,
  } = useCreditUsage();

  const GoIcon = () => <Go className="text-blue group-hover:text-white" />;

  if (!hasCredits) {
    return null;
  }

  const UsageMeter = () => (
    <MeterBox
      className="ck-nav__iconBox"
      max={credits}
      size={24}
      strokeWidth="0.1875rem"
      value={creditsUsed}
    />
  );
  UsageMeter.displayName = 'CKNavigationBarMenu.Icon';

  return (
    <CKNavigationBarMenu popoverPlacement="top-start">
      <UsageMeter />
      <CKNavigationBarMenu.Content>
        {hasUsage || loading ? (
          <div className="space-y-1">
            <CKSkeleton
              className="h-6 w-[14ch] ck-skeleton--white"
              isLoading={loading}
              label="loading"
            >
              <CKNavigationBarMenu.Heading>
                <Metric
                  value={hasCredits ? credits - creditsUsed : 'Unlimited'}
                />
                credits remaining
              </CKNavigationBarMenu.Heading>
            </CKSkeleton>
            <CKSkeleton
              className="h-6 w-[16ch] ck-skeleton--white"
              isLoading={loading}
              label="loading"
            >
              <CKNavigationBarMenu.Subheading className="capitalize">
                {planId?.split('_').join(' ')} Plan
              </CKNavigationBarMenu.Subheading>
            </CKSkeleton>
          </div>
        ) : (
          <div>No Usage Data Available</div>
        )}
        <CKNavigationBarMenu.Menu>
          <CKActionMenu>
            <CKActionMenu.Item
              as={Link}
              className="w-full group"
              leftIcon={<UsageAltNav height={18} width={18} />}
              rightIcon={<GoIcon />}
              to="/settings/usage"
              variant="tertiary"
              variantColor="blue"
            >
              View Usage
            </CKActionMenu.Item>
            <CKActionMenu.Item
              as={Link}
              className="w-full group"
              leftIcon={<SubscriptionNav height={18} width={18} />}
              rightIcon={<GoIcon />}
              to="/settings/team/plans"
              variant="tertiary"
              variantColor="blue"
            >
              Upgrade Plan
            </CKActionMenu.Item>
          </CKActionMenu>
        </CKNavigationBarMenu.Menu>
      </CKNavigationBarMenu.Content>
    </CKNavigationBarMenu>
  );
};
